import { graphql } from '@/gql';
import type { UpdateDeliveryInstructionsMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updateDeliveryInstructions = async ({
  id,
  dropoffOptionId,
  deliveryInstructions,
}: UpdateDeliveryInstructionsMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      id,
      dropoffOptionId,
      deliveryInstructions,
    },
    mutation: graphql(`
      mutation UpdateDeliveryInstructions($id: String!, $dropoffOptionId: String!, $deliveryInstructions: String) {
        updateDeliveryInstructions(id: $id, dropoffOptionId: $dropoffOptionId, deliveryInstructions: $deliveryInstructions) {
          id
        }
      }
    `),
  });

  return response.data?.updateDeliveryInstructions;
};
